const LOCALES = {
  ar: 'ar-SA',
  en: 'en-US',
}

const getSystemLocale = (navigator) => {
  const defaultLocale = LOCALES.ar

  if (!TypeChecker.isNavigator(navigator)) {
    return defaultLocale
  }

  /**
   * Chrome, Fixfox, Opera, Safari, Edge, Mobile browser
   * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/languages
   */
  const locale = navigator.language || defaultLocale
  const isArabicLang = locale.includes('ar')

  return isArabicLang ? LOCALES.ar : LOCALES.en
}

export { getSystemLocale }
